import * as yup from 'yup'; // for everything
export const schema = yup.object().shape({
  code: yup.string().min(2, 'code is too short').required('code is required'),

});
